document.addEventListener('DOMContentLoaded', function() {
  var toggle   = document.getElementById('js-nav-toggle');
  var collapse = document.getElementById('js-nav-collapse');
  var iconOpen  = document.getElementById('js-nav-icon-open');
  var iconClose = document.getElementById('js-nav-icon-close');
  if (!toggle || !collapse) return;

  var LG = 1024;

  function closeMenu() {
    collapse.classList.add('hidden');
    toggle.setAttribute('aria-expanded', 'false');
    if (iconOpen)  iconOpen.classList.remove('hidden');
    if (iconClose) iconClose.classList.add('hidden');
  }

  toggle.addEventListener('click', function() {
    if (window.innerWidth >= LG) return;
    var isOpen = !collapse.classList.contains('hidden');
    collapse.classList.toggle('hidden', isOpen);
    toggle.setAttribute('aria-expanded', String(!isOpen));
    if (iconOpen)  iconOpen.classList.toggle('hidden', !isOpen);
    if (iconClose) iconClose.classList.toggle('hidden', isOpen);
  });

  window.addEventListener('resize', function() {
    if (window.innerWidth >= LG) closeMenu();
  });
});
